// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2AJbE","rootCenter":"LoadMoreObserver_rootCenter__1xL7x","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3-fEj"};